import {LocaleEnum} from '@enums/locale';

export const normalizeApiLocale = (locale?: string | null): LocaleEnum => {
  if (locale === 'sv') {
    return LocaleEnum.SE;
  }

  return (locale as LocaleEnum) || LocaleEnum.FI;
};
